import { TOOLBAR_BUTTON_SX } from "@/controls/buttons/toolbarButton";
import { ResetFiltersButton } from "@/controls/buttons/ResetFiltersButton";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import {
	Autocomplete,
	Box,
	Button,
	Checkbox,
	FormControlLabel,
	IconButton,
	InputAdornment,
	MenuItem,
	TextField,
} from "@mui/material";
import { CREWS } from "../../straightener-common/constants";

interface Props {
	search: string;
	onSearchChange: (value: string) => void;
	productType: string;
	onProductTypeChange: (value: string) => void;
	productTypes: string[];
	crew: string;
	onCrewChange: (value: string) => void;
	withRecipe: boolean;
	onWithRecipeChange: (value: boolean) => void;
	onAdd: () => void;
	canAdd: boolean;
	onReset: () => void;
	canReset: boolean;
}

export const StraightenerRecipesToolbar = ({
	search,
	onSearchChange,
	productType,
	onProductTypeChange,
	productTypes,
	crew,
	onCrewChange,
	withRecipe,
	onWithRecipeChange,
	onAdd,
	canAdd,
	onReset,
	canReset,
}: Props) => (
	<Box
		sx={{
			display: "flex",
			alignItems: "center",
			gap: 1,
			flexWrap: "wrap",
			px: 1.5,
			py: 0.75,
		}}
	>
		<Autocomplete
			size="small"
			options={["", ...productTypes]}
			value={productType}
			disableClearable
			autoHighlight
			getOptionLabel={(t) => t || "All types"}
			onChange={(_event, t) => onProductTypeChange(t ?? "")}
			sx={{ width: 180 }}
			renderInput={(params) => (
				<TextField
					{...params}
					label="Product type"
					slotProps={{ inputLabel: { shrink: true } }}
				/>
			)}
		/>
		<TextField
			size="small"
			label="Crew"
			select
			value={crew}
			onChange={(e) => onCrewChange(e.target.value)}
			sx={{ width: 130 }}
			slotProps={{
				inputLabel: { shrink: true },
				select: { displayEmpty: true },
			}}
		>
			<MenuItem value="">All crews</MenuItem>
			{CREWS.map((c) => (
				<MenuItem key={c} value={c}>
					Crew {c}
				</MenuItem>
			))}
		</TextField>
		<TextField
			size="small"
			placeholder="Search product..."
			value={search}
			onChange={(e) => onSearchChange(e.target.value)}
			sx={{ width: 220 }}
			slotProps={{
				input: {
					endAdornment: search ? (
						<InputAdornment position="end">
							<IconButton
								size="small"
								aria-label="clear search"
								edge="end"
								onClick={() => onSearchChange("")}
							>
								<ClearIcon fontSize="small" />
							</IconButton>
						</InputAdornment>
					) : undefined,
				},
			}}
		/>
		<FormControlLabel
			sx={{ mr: 0 }}
			control={
				<Checkbox
					size="small"
					checked={withRecipe}
					onChange={(e) => onWithRecipeChange(e.target.checked)}
				/>
			}
			label="With recipe"
		/>
		<ResetFiltersButton onClick={onReset} disabled={!canReset} />

		<Box sx={{ flex: 1 }} />
		{canAdd ? (
			<Button
				variant="contained"
				color="primary"
				startIcon={<AddIcon />}
				onClick={onAdd}
				size="medium"
				sx={TOOLBAR_BUTTON_SX}
			>
				CREATE RECIPE
			</Button>
		) : null}
	</Box>
);
